export const badges = [
  {
    id: "intermediate",
    class: "primary",
    type: "intermediate",
    label: "APP.NETZEBW",
    key: "NOTIFICATION_SERVICE.NETZEBW_DESCRIPTION"
  },
  {
    class: "secondary",
    id: "startEnd",
    type: "startEnd",
    label: "APP.MUNICIPALITY",
    key: "NOTIFICATION_SERVICE.MUNICIPALITY_DESCRIPTION"
  },
  {
    id: "dataStorage",
    class: "documents",
    type: "dataStorage",
    label: "NOTIFICATION_SERVICE.DOCUMENTS",
    key: "NOTIFICATION_SERVICE.EDIT.ACCOUNTING.NEW_DOCUMENTS"
  }
];
